import request from '@/utils/request' // 引入封装的request.js文件

// 提交总结
export function summaryAdd(data) {
  return request({
    url: '/summary/insert',
    method: 'post',
    data
  })
}

// 上传文件
export function uploadFile(data) {
  return request({
    url: '/common/upload',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Cache-Control': 'no-cache',
      'Accept': '*/*',
      'Authorization': localStorage.getItem('token')
    }
  })
}